import { Link } from '@tanstack/react-router';
import { useSession } from '../../lib/auth/session.js';
import { logout } from '../../lib/api/client.js';
import { Icon } from '../ui/Icon.js';

/**
 * Who is signed in, their account page, and signing out. One component, so the console's header
 * and an account's own TMS show the same thing (26 September 2026: a client's admin lands in their
 * account's TMS, which had no way to sign out).
 */
export function UserMenu() {
  const session = useSession((s) => s.session);
  const clear = useSession((s) => s.clear);
  const initials = (session?.user.full_name ?? session?.user.email ?? '?')
    .split(/[\s@.]+/).filter(Boolean).slice(0, 2).map((s) => s[0]?.toUpperCase()).join('');
  return (
    <div className="arc-row" style={{ gap: 7 }}>
      {/* Your own account and its security (two-step verification). */}
      <Link to="/account/security" className="arc-row" title="Your account"
        style={{ gap: 7, color: 'inherit', textDecoration: 'none' }}>
        <div className="arc-avatar" aria-hidden="true">{initials}</div>
        <div className="arc-stack" style={{ lineHeight: 1.25 }}>
          <span style={{ fontSize: 12.5, fontWeight: 550 }}>
            {session?.user.full_name ?? session?.user.email}
          </span>
          <span className="arc-subtle" style={{ fontSize: 11 }}>
            {session?.memberships[0]?.role_name ?? '—'}
          </span>
        </div>
      </Link>
      <button
        type="button" className="arc-btn arc-btn-ghost arc-btn-icon"
        onClick={() => { void logout().then(clear); }}
        title="Sign out" aria-label="Sign out"
      >
        <Icon name="logout" size={15} />
      </button>
    </div>
  );
}
